export default {
    data () {

    },
    methods: {
        toHome () {
            this.$router.push('/')
        }
    }
}